import ProgramSettings from '@/components/settings/ProgramSettings'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTranslation } from '@/hooks/useTranslation'

const ProgramSettingsPage = () => {
	const { t } = useTranslation()
	return (
		<div className="p-4 md:p-8 max-w-5xl mx-auto space-y-6">
			<Tabs defaultValue="settings" className="space-y-4">
				
				<TabsContent value="settings">
					<ProgramSettings />
				</TabsContent>
				
				
			</Tabs>
		</div>
	)
}

export default ProgramSettingsPage
